import React from 'react';
import { baseXUnit, color, spacing } from '../../styles/theme';
import H from '../elements/H';
import { t } from '../../utils/i18n';
import Spacing from '../common/Spacing';
import Paragraph from '../elements/Paragraph';
import Row from '../grid/Row';
import Col from '../grid/Col';

const CollaborationCard: React.FunctionComponent = () => {
  return (
    <div className="collaboration-card" data-testid="collaboration-card">
      <Spacing left={[2, 2, 4]} right={[2, 2, 4]}>
        <Row>
          <Col size={24}>
            <Spacing top={[1, 1, 2]} bottom={3}>
              <H styling="h2">
                <strong>
                  {t('Mikä on')}{' '}
                  <img src="/x-imt.svg" alt="x" className="accent-logo" />{' '}
                  IMT.fi?
                </strong>
              </H>
            </Spacing>
          </Col>
        </Row>
        <Row>
          <Col size={24}>
            <Spacing bottom={2}>
              <Paragraph>
                {t('Me uskomme, että parhaat asiat syntyvät')}{' '}
                <strong>{t('yhteistyössä')}</strong>.
                {t(
                  ' Tästä ajatuksesta – ja rakkaudesta urheiluun – on syntynyt'
                )}{' '}
                <strong>{t('x IMT.fi')}</strong>.
              </Paragraph>
            </Spacing>
            <Spacing bottom={2}>
              <Paragraph>
                {t('Kirjain ')}
                <strong>{t('x')}</strong>{' '}
                {t(
                  'symboloi yhteistyötä: kun eri toimijat yhdistävät osaamisensa, syntyy jotain parempaa.'
                )}
              </Paragraph>
            </Spacing>
            <Spacing bottom={2}>
              <Paragraph>
                {t(
                  'Yhteistyö on meille tuttua jo vuosikymmenten ajalta. Olemme rakentaneet matkoja yhdessä laivayhtiöiden, hotellien ja muiden kumppaneiden kanssa matkatoimistomme alusta asti, '
                )}
                <strong>{t('vuodesta 1991')}</strong>.
                {t(' Tuolloin toimimme nimellä ')}
                <strong>{t('Ikaalisten Matkatoimisto')}</strong>.
                {t(' Tänä aikana ')}
                <strong>{t('miljoonat matkailijat')}</strong>{' '}
                {t('ovat matkustaneet kauttamme lahden yli.')}
              </Paragraph>
            </Spacing>
            <Spacing bottom={1}>
              <Paragraph>
                {t('Nykyisellään ')}
                <strong>{t('IMT.fi')}</strong>{' '}
                {t(
                  'on yksi johtavista Viron matkojen myyjistä Suomessa. Voit tutustua tarkemmin palveluihimme'
                )}{' '}
                <a
                  href="https://www.imt.fi"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="imt-link"
                >
                  {t('Täällä')}
                </a>
                .
              </Paragraph>
            </Spacing>
          </Col>
        </Row>
      </Spacing>
      {/*language=CSS*/}
      <style jsx>{`
        .collaboration-card {
          border-radius: ${baseXUnit(1)};
          box-shadow: 0 2px ${baseXUnit(2)} 0 rgba(0, 0, 0, 0.15);
          padding-top: ${spacing.two};
          padding-bottom: ${spacing.two};
          background-color: ${color.white};
        }
        .accent-logo {
          height: 0.8em;
          vertical-align: middle;
          margin-bottom: 0.1em;
        }
        .imt-link {
          text-decoration: underline;
          color: inherit;
        }
      `}</style>
    </div>
  );
};

export default CollaborationCard;
